var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Mixins } from 'vue-property-decorator';
import OptionBar from './DomTree/OptionBar';
import DomTree from './DomTree';
import ConfigPanel from './ConfigPanel';
import devToolMixin from '../../util/devToolMixin';
import { vueLinkLocalStorage } from "../../../../../lib/utils/vue";
let default_1 = class extends Mixins(devToolMixin) {
  constructor() {
    var _this$windowOptions, _this$container;
    super(...arguments);
    this.extraWidth = 0;
    this.rightWidth = (((_this$windowOptions = this.windowOptions) === null || _this$windowOptions === void 0 ? void 0 : _this$windowOptions.width) - 40) / 2 || 300;
    this.bottomRightWidth = window.innerWidth / 2 || 300;
    this.extraHeight = 0;
    this.rightHeight = ((_this$container = this.container) === null || _this$container === void 0 ? void 0 : _this$container.offsetHeight) / 2 || 300;
    this.observer = null;
  }
  get leftWidth() {
    return this.windowOptions.width - 40 - this.rightWidth;
  }
  get bottomLeftWidth() {
    return window.innerWidth - this.bottomRightWidth;
  }
  created() {
    vueLinkLocalStorage(this, 'UcDevTool', 'rightWidth');
    vueLinkLocalStorage(this, 'UcDevTool', 'rightHeight');
    vueLinkLocalStorage(this, 'UcDevTool', 'bottomRightWidth');
  }
  beforeDestroy() {
    var _this$observer;
    (_this$observer = this.observer) === null || _this$observer === void 0 || _this$observer.disconnect();
  }
  mounted() {
    var _this$$refs$configPan;
    const el = this.displayMode === 'seperate' || this.displayMode === 'bottom' ? this.$el : (_this$$refs$configPan = this.$refs.configPanel) === null || _this$$refs$configPan === void 0 ? void 0 : _this$$refs$configPan.$el;
    this.observer = new ResizeObserver(entries => {
      const entry = entries[0];
      if (this.extraHeight === 0) this.rightHeight = (entry === null || entry === void 0 ? void 0 : entry.contentRect.height) || 300;
    });
    if (el) this.observer.observe(el);
  }
  handleReiszePanel(delta) {
    if (this.displayMode === 'seperate' || this.displayMode === 'bottom') {
      this.extraWidth = delta;
    } else {
      console.log(this.extraHeight);
      this.extraHeight = delta;
    }
  }
  render() {
    const h = arguments[0];
    if (this.displayMode === 'seperate') {
      return h("div", {
        "class": "ucd-devTool-layout",
        "ref": "configPanel",
        "style": {
          'grid-template-columns': `${this.leftWidth + this.extraWidth}px ${this.rightWidth - this.extraWidth}px`
        }
      }, [h(OptionBar), h(DomTree), h(ConfigPanel, {
        "on": {
          "resizePanel": this.handleReiszePanel,
          "resizePanelEnd": () => {
            this.rightWidth -= this.extraWidth;
            this.extraWidth = 0;
          }
        }
      })]);
    }
    if (this.displayMode === 'bottom') {
      return h("div", {
        "class": "ucd-devTool-layout",
        "ref": "configPanel",
        "style": {
          'grid-template-columns': `${this.bottomLeftWidth + this.extraWidth}px ${this.bottomRightWidth - this.extraWidth}px`
        }
      }, [h(OptionBar), h(DomTree), h(ConfigPanel, {
        "on": {
          "resizePanel": this.handleReiszePanel,
          "resizePanelEnd": () => {
            this.bottomRightWidth -= this.extraWidth;
            this.extraWidth = 0;
          }
        }
      })]);
    }
    return h("div", {
      "class": "ucd-devTool-layout-vertical"
    }, [h(OptionBar), h(DomTree), h(ConfigPanel, {
      "style": {
        maxHeight: `${Math.min(this.rightHeight - this.extraHeight, this.container.offsetHeight - 300)}px`,
        flex: `${this.rightHeight - this.extraHeight} 0 ${this.rightHeight - this.extraHeight}px`,
        minHeight: '100px'
      },
      "on": {
        "resizePanel": this.handleReiszePanel,
        "resizePanelEnd": () => {
          this.rightHeight -= this.extraHeight;
          this.extraHeight = 0;
        }
      },
      "ref": "configPanel"
    })]);
  }
};
default_1 = __decorate([Component({
  name: 'LayoutPanel'
})], default_1);
export default default_1;